import { isGenericValue } from './generic-typeguards';
import { GenericValue } from 'hisng';

export const isRecord = ( r: unknown ): r is Record<string, unknown> => {
    return typeof r === 'object' && r != null;
};

export const getNumber = ( r: Record<string, unknown>, key: string ): number | undefined => {
    const value = r[key];
    return typeof value === 'number' ? value : undefined;
};

export const getString = ( r: Record<string, unknown>, key: string ): string | undefined => {
    const value = r[key];
    return typeof value === 'string' ? value : undefined;
};

export const getBoolean = ( r: Record<string, unknown>, key: string ): boolean | undefined => {
    const value = r[key];
    return typeof value === 'boolean' ? value : undefined;
};

export const getDate = ( r: Record<string, unknown>, key: string ): Date | undefined => {
    const value = r[key];
    if ( typeof value === 'string' && !isNaN( Date.parse( value ) ) ) {
        return new Date( value );
    } else if ( typeof value === 'number' ) {
        return new Date( value );
    } else {
        return undefined;
    }
};

export const getGenericValue = ( r: Record<string, unknown>, key: string ): GenericValue | undefined => {
    return getT( r, key, isGenericValue );
};

export const getT = <T>( r: Record<string, unknown>, key: string, isT: ( t: unknown ) => t is T ): T | undefined => {
    const value = r[key];
    return isT( value ) ? value : undefined;
};
